import moment from 'moment'

const eventsFiltersPresets = [
  {
    name: 'Прошедшие',
    slug: 'past',
    form: {
      dateSort: 'ascending',
      filters: {
        dateFrom: moment().subtract(6, 'month').format('DD.MM.YYYY'),
        dateTo: moment().format('DD.MM.YYYY'),
        locations: [],
        types: []
      }
    }
  },
  {
    name: 'Будущие',
    slug: 'future',
    form: {
      dateSort: 'ascending',
      filters: {
        dateFrom: moment().format('DD.MM.YYYY'),
        dateTo: moment().add(6, 'month').format('DD.MM.YYYY'),
        locations: [],
        types: []
      }
    }
  },
  {
    name: 'Все',
    slug: 'all',
    form: {
      dateSort: 'ascending',
      filters: {
        dateFrom: moment().subtract(12, 'month').format('DD.MM.YYYY'),
        dateTo: moment().add(6, 'month').format('DD.MM.YYYY'),
        locations: [],
        types: []
      }
    }
  }
]

export default eventsFiltersPresets